<template>
  <div id="contenedor-colonias">
    <v-container fluid>
      <v-card flat class="mb-4 rounded-lg">
        <v-card-text>
          <titulo-tool-bar titulo="Catálogo de Colonias" class="rounded-xl">
            <template v-slot:opciones-derecha>
              <v-btn
                color="primary"
                class="white--text"
                rounded
                @click="dialog = true"
              >
                <v-icon left>mdi-plus</v-icon>
                Agregar
              </v-btn>
            </template>
          </titulo-tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="listadoColonias"
            :items-per-page="5"
          >
            <template v-slot:item.acciones="{ item }">
              <v-icon
                class="mr-2"
                color="blue darken-2"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                class="mr-2"
                color="red darken-2"
                @click="catalogoColoniaEliminar = item; showDialogEliminar = true"
              >
                mdi-delete
              </v-icon>
            </template>
            <template v-slot:no-data>
              No hay colonias registradas.
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog v-model="dialog" max-width="600px" scrollable persistent>
      <agregar-colonia @cerrar="dialog = false" />
    </v-dialog>
    <v-dialog v-model="showDialogEliminar" max-width="500px" persistent>
      <v-card>
        <v-card-title class="secondary--text">
          Confirmar eliminación
          <v-spacer></v-spacer>
          <v-btn icon @click="showDialogEliminar = false">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          ¿Está seguro que desea eliminar la colonia
          <strong>{{ catalogoColoniaEliminar.descripcion }}</strong>?
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="showDialogEliminar = false"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixEliminarCatalogoColonia(catalogoColoniaEliminar.id)"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Eliminar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import TituloToolBar from '@/components/TituloToolBar.vue';
import AgregarColonia from '@/components/administracion/configuracion/catalogos/colonias/Agregar.vue';
import mixCatalogoColonias from '@/components/administracion/configuracion/catalogos/colonias/mixCatalogoColonias';

export default {
  name: 'CatalogoColoniasView',
  mixins: [mixCatalogoColonias],
  components: {
    TituloToolBar,
    AgregarColonia,
    CustomButton,
  },
  data() {
    return {
      dialog: false,
      showDialogEliminar: false,
      catalogoColoniaEliminar: {},
      headers: [
        { text: 'Localidad', value: 'localidad.descripcion' },
        { text: 'Colonia', value: 'descripcion' },
        {
          text: 'Acciones', value: 'acciones', sortable: false, width: '200px',
        },
      ],
    };
  },
  methods: {
    async preEliminarCatalogoColonia(id) {
      await this.mixEliminarCatalogoColonia(id).then(() => {
        this.catalogoColoniaEliminar = {};
        this.showDialogEliminar = false;
      });
    },
    cerrar() {
      this.dialog = false;
    },
  },
  computed: {
    listadoColonias() {
      if (!this.catalogoColonias) {
        return [];
      }

      return this.catalogoColonias;
    },
  },
};
</script>

<style lang="scss">

</style>
